import type { ComponentPropsWithoutRef, ElementType } from "react";
import { cn } from "../../utils/cn";

type DSTypographyProps<T extends ElementType = "p"> = {
  as?: T;
} & Omit<ComponentPropsWithoutRef<T>, "as">;

function DSTypography<T extends ElementType = "p">({
  as,
  className,
  ...rest
}: DSTypographyProps<T>) {
  const Component = as ?? "p";

  return (
    <Component
      className={cn("font-inter font-semibold text-[14px] leading-[normal] tracking-[0px] text-dark-3", className)}
      {...rest}
    />
  );
}

export { DSTypography };
export type { DSTypographyProps };
